import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import { toast } from "react-toastify";

import Header from "../../../component/organisms/header";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import Sidebar from "../../../component/organisms/sidebar";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import TableTitle from "./../../../component/atoms/text/table/tableTitle";
import TableTop from "./../../../component/atoms/layout/table/tableTop";
import TableCount from "./../../../component/molecules/tableCount";
import SearchBar from "./../../../component/atoms/input/searchBar";
import ExcelBtn from "./../../../component/atoms/button/excelBtn";
import Pagination from "./../../../component/molecules/pagination";
import { route } from "./../../../router/route";
import Table from "../../../component/atoms/layout/table/table";
import Tr from "./../../../component/atoms/layout/table/tr";
import Th from "./../../../component/atoms/layout/table/th";
import Checkbox from "./../../../component/atoms/input/checkbox";
import TableText from "./../../../component/atoms/text/table/tableText";
import Td from "./../../../component/atoms/layout/table/td";
// import moment from "moment";
import { formatNumberWithCommas } from "./../../../util/formatNumber";
import GrayBtn from "../../../component/atoms/button/grayBtn";
import PopupOverLay from "../../../component/templates/PopupOverlay";
import Popup from "../../../component/molecules/popup";
import PretendardText from "../../../component/atoms/text/pretendardText";

import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import scrollToTop from "./../../../util/scrollToTop";
import DetailBtn from "./../../../component/atoms/button/detailBtn";

import Radio from "./../../../component/atoms/input/radio";
import EventBtn from "../../../component/atoms/button/eventBtn";
import WritingLinkApi from "../../../api/writingLink.api";
import AlarmSendPopup from "../../../component/templates/user/userInfo/alarmSendPopup";
import SMSSendPopup from "../../../component/templates/user/userInfo/smsSendPopup";

import WLPointChange from "../../../component/organisms/writingLink/wlPointChange";

// TODO:
// - 초대 계정 포인트 변경, 초대 계정에 알림 보내기, 초대 계정에 SMS 보내기 작업 필요

// sessionStorage 초기화
function sessionStorageInit() {
  sessionStorage.removeItem("sCheckedListStorage");
  const event = new Event("sessionStorageChange");
  window.dispatchEvent(event);
}

const WritingLink = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const [keyword, setKeyword] = useState("");
  const [distributeFilter, setDistributeFilter] = useState(null);
  const [isWriteAuthority, setIsWriteAuthority] = useState(false);

  // ---------- 쓰기 권한체크 ---------- //
  useEffect(() => {
    const writeMenu = sessionStorage.getItem("writeMenu");

    if (writeMenu?.includes(route.crew_link)) {
      setIsWriteAuthority(true);
    } else {
      setIsWriteAuthority(false);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const page = useMemo(() => {
    return searchParams.get("page") ? searchParams.get("page") : 1;
  }, [searchParams]);

  const [pagination, setPagination] = useState({
    size: 10, // 한 페이지에 표시될 게시글 수
    rangeSize: 5, // 하단 페이지 사이즈
    totalCount: 0,
    totalPages: 0,
    first: false,
    last: false,
  });

  useEffect(() => {
    return () => {
      sessionStorage.removeItem("sCheckedListStorage");
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // ---------- 마운트가 되면 ---------- //
  useEffect(() => {
    setKeyword(searchParams.get("keyword") ? searchParams.get("keyword") : "");

    if (searchParams.get("distribute")) {
      setDistributeFilter(
        searchParams.get("distribute") === "false" ? false : true
      );
    } else {
      setDistributeFilter(null);
    }

    getWritingLinkSettingStatus();
    getWritingLinkList();
  }, [location]); // eslint-disable-line react-hooks/exhaustive-deps

  // ---------- 라이팅링크 리스트 관련 ---------- //
  const [writingLinkList, setWritingLinkList] = useState([]);
  const [writingLinkTotalCount, setWritingLinkTotalCount] = useState(0);

  // 라이팅링크 리스트 조회
  const getWritingLinkList = async () => {
    try {
      const data = {
        page: Number(page),
        size: Number(pagination.size),
      };

      if (keyword) {
        data.keyword = searchParams.get("keyword");
      }

      if (searchParams.get("distribute") === "true") {
        data.distributeStatus = "Active";
      } else if (searchParams.get("distribute") === "false") {
        data.distributeStatus = "Inactive";
      }

      const response = (await WritingLinkApi.getListHistory(data)).data.data;

      const processedResponse = response.content.map((item, index) => {
        return {
          ...item,
          numbering: response.totalCount - (page - 1) * pagination.size - index,
          checked: false,
        };
      });

      setWritingLinkList(processedResponse);

      setWritingLinkTotalCount(response.totalCount);

      setPagination({
        ...pagination,
        totalCount: response.totalCount,
        totalPages: Math.ceil(response.totalCount / 10),
      });
    } catch (error) {
      console.error(error);
    }
  };

  // ---------- 라이팅링크 설정 관련 ---------- //
  const [popupOpen, setPopupOpen] = useState(false);
  const [writingLinkSettingStatus, setWritingLinkSettingStatus] =
    useState(false);

  // 라이팅링크 설정 상태 조회
  const getWritingLinkSettingStatus = async () => {
    try {
      const response = (await WritingLinkApi.getSettingStatus()).data.data
        .content;

      setWritingLinkSettingStatus(response.activation);
    } catch (error) {
      console.error(error);
    }
  };

  // 라이팅링크 설정 상태 수정
  const updateWritingLinkSettingStatus = async () => {
    try {
      const data = {
        activation: writingLinkSettingStatus,
      };

      await WritingLinkApi.updateSettingStatus(data);

      getWritingLinkSettingStatus();

      setPopupOpen(false);
      toast("라이팅링크 설정이 변경되었습니다.");
    } catch (error) {
      console.error(error);
    }
  };

  // ---------- 체크 관련 ---------- //
  const sessionStorageCheckedList = sessionStorage.getItem(
    "sCheckedListStorage"
  );
  const [checkedListStorage, setCheckedListStorage] = useState([]);
  const [isAllCheck, setIsAllCheck] = useState(false);

  useEffect(() => {
    const handleStorageChange = () => {
      setCheckedListStorage(
        sessionStorageCheckedList ? JSON.parse(sessionStorageCheckedList) : []
      );
    };

    window.addEventListener("sessionStorageChange", handleStorageChange);

    return () => {
      window.removeEventListener("sessionStorageChange", handleStorageChange);
    };
  }, []); // eslint-disable-line

  useEffect(() => {
    sessionStorage.setItem(
      "sCheckedListStorage",
      JSON.stringify(checkedListStorage)
    );
  }, [page]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (writingLinkList.length > 0) {
      const idsInArray1 = new Set(checkedListStorage.map((item) => item.id));

      const allIdsIncluded = writingLinkList.every((item) =>
        idsInArray1.has(item.id)
      );

      setIsAllCheck(allIdsIncluded);
    }

    if (checkedListStorage.length > 0) {
      setButtonGroupOpen(true);
    } else {
      setButtonGroupOpen(false);
    }
  }, [checkedListStorage, writingLinkList]); /// eslint-disable-line react-hooks/exhaustive-deps

  // ---------- 버튼 그룹 관련 ---------- //
  const [buttonGroupOpen, setButtonGroupOpen] = useState(false);
  const [buttonGroupFilterOpen, setButtonGroupFilterOpen] = useState({
    pointChange: false, // 초대 계정 포인트 변경
    provideType: false, // 지급형태 변경
    provideStatus: false, // 지급상태 변경
  });

  // ---------- 지급형태 변경 관련 ---------- //
  const updateProvideType = async (id, cashFlag) => {
    try {
      const data = {
        activation: cashFlag,
      };

      await WritingLinkApi.updateCash(id, data);

      getWritingLinkList();

      setButtonGroupFilterOpen({
        pointChange: false,
        provideType: false,
        provideStatus: false,
      });
    } catch (error) {
      console.error(error);
    }
  };

  // ---------- 지급상태 변경 관련 ---------- //
  const updateDistributeStatus = async (id, distributeStatus) => {
    try {
      const data = {
        activation: distributeStatus,
      };

      await WritingLinkApi.updateDistribute(id, data);

      getWritingLinkList();

      setButtonGroupFilterOpen({
        pointChange: false,
        provideType: false,
        provideStatus: false,
      });
    } catch (error) {
      console.error(error);
    }
  };

  // ---------- 테이블 지급 상태 필터링 관련 ---------- //
  const [filterOpen, setFilterOpen] = useState(false);

  const [alarmPopupOpen, setAlarmPopupOpen] = useState(false);
  const [smsPopupOpen, setSMSPopupOpen] = useState(false);

  return (
    <>
      <Header />
      <MainLayout
        style={{
          position: "relative",
          gap: 306,
        }}
      >
        <Sidebar />

        {/* 본문 영역 */}
        <DetailPageLayout>
          <TableTitle>라이팅링크</TableTitle>
          {/* 테이블 상단 영역 */}
          <TableTop>
            <TableCount
              fullText={"총 라이팅링크 유입"}
              count={writingLinkTotalCount}
            />
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
              }}
            >
              <SearchBar
                value={keyword}
                placeholder={"이름, 아이디(이메일)"}
                onChange={(e) => {
                  setKeyword(e.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    if (keyword === "") {
                      navigate(route.crew_link, {
                        replace: true,
                      });
                    } else {
                      let link = `${route.crew_link}?page=1`;

                      if (keyword) {
                        link += `&keyword=${keyword}`;
                      }

                      navigate(link, {
                        replace: true,
                      });
                    }
                  }
                }}
                onClick={() => {
                  if (keyword === "") {
                    navigate(route.crew_link, {
                      replace: true,
                    });
                  } else {
                    let link = `${route.crew_link}?page=1`;

                    if (keyword) {
                      link += `&keyword=${keyword}`;
                    }

                    navigate(link, {
                      replace: true,
                    });
                  }
                }}
              />
              {/* <ExcelBtn /> */}
              {isWriteAuthority && (
                <EventBtn
                  text={"라이팅링크 설정"}
                  onClick={() => {
                    setPopupOpen(true);
                  }}
                />
              )}
            </div>
          </TableTop>

          {/* 버튼 그룹 */}
          {buttonGroupOpen && isWriteAuthority && (
            <div
              style={{
                width: "100%",
                height: 49,
                display: "flex",
                gap: 12,
              }}
            >
              <div
                style={{
                  height: "fit-content",
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  position: "relative",
                }}
              >
                <GrayBtn
                  onClick={() => {
                    setButtonGroupFilterOpen({
                      pointChange: !buttonGroupFilterOpen.pointChange,
                      provideType: false,
                      provideStatus: false,
                    });
                  }}
                >
                  초대 계정 포인트 변경
                </GrayBtn>
                {buttonGroupFilterOpen.pointChange && (
                  <WLPointChange
                    userCheckedIdList={checkedListStorage}
                    getMemberList={getWritingLinkList}
                    sessionStorageInit={sessionStorageInit}
                    setButtonGroupOpen={setButtonGroupOpen}
                    setButtonGroupFilterOpen={setButtonGroupFilterOpen}
                  />
                )}
              </div>
              <GrayBtn
                onClick={() => {
                  setAlarmPopupOpen(true);
                }}
              >
                초대 계정에 알림 보내기
              </GrayBtn>
              <GrayBtn
                onClick={() => {
                  setSMSPopupOpen(true);
                }}
              >
                초대 계정에 SMS 보내기
              </GrayBtn>

              {checkedListStorage && checkedListStorage.length === 1 && (
                <>
                  <div
                    style={{
                      height: "fit-content",
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                      position: "relative",
                    }}
                  >
                    <GrayBtn
                      onClick={() => {
                        setButtonGroupFilterOpen({
                          pointChange: false,
                          provideType: !buttonGroupFilterOpen.provideType,
                          provideStatus: false,
                        });
                      }}
                    >
                      지급형태 변경
                    </GrayBtn>
                    {buttonGroupFilterOpen.provideType && (
                      <FilterWrapper
                        style={{
                          width: 115,
                          top: 36,
                        }}
                      >
                        <FilterTextWrapper>
                          <FilterText
                            onClick={() => {
                              const checkedData = checkedListStorage[0];

                              updateProvideType(checkedData.id, false);
                            }}
                          >
                            포인트
                            {!checkedListStorage[0].cashFlag && (
                              <img
                                src="/assets/admin/icons/ico_selectbox_checked.svg"
                                alt="포인트 선택됨"
                              />
                            )}
                          </FilterText>
                        </FilterTextWrapper>
                        <FilterText
                          onClick={() => {
                            const checkedData = checkedListStorage[0];

                            updateProvideType(checkedData.id, true);
                          }}
                        >
                          현금
                          {checkedListStorage[0].cashFlag && (
                            <img
                              src="/assets/admin/icons/ico_selectbox_checked.svg"
                              alt="현금 선택됨"
                            />
                          )}
                        </FilterText>
                      </FilterWrapper>
                    )}
                  </div>
                  <div
                    style={{
                      height: "fit-content",
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                      position: "relative",
                    }}
                  >
                    <GrayBtn
                      onClick={() => {
                        setButtonGroupFilterOpen({
                          pointChange: false,
                          provideType: false,
                          provideStatus: !buttonGroupFilterOpen.provideStatus,
                        });
                      }}
                    >
                      상태 변경
                    </GrayBtn>
                    {buttonGroupFilterOpen.provideStatus && (
                      <FilterWrapper
                        style={{
                          width: 115,
                          top: 36,
                        }}
                      >
                        <FilterTextWrapper>
                          <FilterText
                            onClick={() => {
                              const checkedData = checkedListStorage[0];

                              updateDistributeStatus(checkedData.id, true);
                            }}
                          >
                            지급완료
                            {checkedListStorage[0].distributeStatus && (
                              <img
                                src="/assets/admin/icons/ico_selectbox_checked.svg"
                                alt="지급완료 선택됨"
                              />
                            )}
                          </FilterText>
                        </FilterTextWrapper>
                        <FilterText
                          onClick={() => {
                            const checkedData = checkedListStorage[0];

                            updateDistributeStatus(checkedData.id, false);
                          }}
                        >
                          미지급
                          {!checkedListStorage[0].distributeStatus && (
                            <img
                              src="/assets/admin/icons/ico_selectbox_checked.svg"
                              alt="미지급 선택됨"
                            />
                          )}
                        </FilterText>
                      </FilterWrapper>
                    )}
                  </div>
                </>
              )}
            </div>
          )}

          {/* 테이블 영역 */}
          <Table>
            <colgroup>
              {/* 합계: 1044px */}
              {/* 체크박스 */}
              <col width="60px" />
              {/* No */}
              <col width="44px" />
              {/* 라이팅링크로 유입된 계정 */}
              <col width="210px" />
              {/* 초대한 계정 */}
              <col width="244px" />
              {/* 지급 형태 */}
              <col width="108px" />
              {/* 지급 금액 */}
              <col width="145px" />
              {/* 상태 */}
              <col width="128px" />
              {/* 보기 */}
              <col width="105px" />
            </colgroup>
            <thead>
              <Tr style={{ height: "41px", background: "#272829" }}>
                <Th style={{ paddingLeft: "20px" }}>
                  <Checkbox
                    checked={isAllCheck}
                    onChange={(e) => {
                      if (e.target.checked) {
                        // 배열 병합 및 중복 제거
                        const mergedArray = [
                          ...writingLinkList,
                          ...checkedListStorage,
                        ].reduce((acc, current) => {
                          const existingItem = acc.find(
                            (item) => item.id === current.id
                          );
                          if (!existingItem) {
                            acc.push(current);
                          }
                          return acc;
                        }, []);

                        setCheckedListStorage(mergedArray);
                      } else {
                        const idsToExclude = new Set(
                          writingLinkList.map((item) => item.id)
                        );
                        const filteredArray = checkedListStorage.filter(
                          (item) => !idsToExclude.has(item.id)
                        );

                        setCheckedListStorage(filteredArray);
                      }
                    }}
                  />
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    No
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    라이팅링크로 유입된 계정
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    초대한 계정
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    지급 형태
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    지급 금액
                  </TableText>
                </Th>
                <Th>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                      cursor: "pointer",
                      position: "relative",
                    }}
                  >
                    <TableText
                      style={{
                        fontWeight: "600",
                        lineHeight: "22.75px",
                      }}
                    >
                      상태
                    </TableText>
                    <img
                      className={filterOpen === true ? "rotate" : "rotate-back"}
                      src="/assets/admin/icons/ico_arrow_down.svg"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setFilterOpen(!filterOpen);
                      }}
                      alt="필터 펼치기/접기"
                    />
                    {filterOpen && (
                      <FilterWrapper>
                        <FilterTextWrapper>
                          <FilterText
                            onClick={() => {
                              if (searchParams.get("distribute") === "true") {
                                navigate(
                                  `${route.crew_link}?page=1${
                                    keyword && `&keyword=${keyword}`
                                  }`
                                );

                                setFilterOpen(false);
                                return;
                              }

                              navigate(
                                `${route.crew_link}?page=1&distribute=${true}${
                                  keyword && `&keyword=${keyword}`
                                }`
                              );

                              setFilterOpen(false);
                            }}
                          >
                            지급완료
                            {distributeFilter && (
                              <img
                                src="/assets/admin/icons/ico_selectbox_checked.svg"
                                alt="지급완료 선택됨"
                              />
                            )}
                          </FilterText>
                        </FilterTextWrapper>
                        <FilterText
                          onClick={() => {
                            if (searchParams.get("distribute") === "false") {
                              navigate(
                                `${route.crew_link}?page=1${
                                  keyword && `&keyword=${keyword}`
                                }`
                              );

                              setFilterOpen(false);
                              return;
                            }

                            navigate(
                              `${route.crew_link}?page=1&distribute=${false}${
                                keyword && `&keyword=${keyword}`
                              }`
                            );

                            setFilterOpen(false);
                          }}
                        >
                          미지급
                          {distributeFilter === false && (
                            <img
                              src="/assets/admin/icons/ico_selectbox_checked.svg"
                              alt="미지급 선택됨"
                            />
                          )}
                        </FilterText>
                      </FilterWrapper>
                    )}
                  </div>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    보기
                  </TableText>
                </Th>
              </Tr>
            </thead>
            <tbody>
              {writingLinkList.map((item, index) => {
                return (
                  <Tr
                    key={index}
                    style={{
                      height: "69px",
                      background: "transparent",
                      borderBottom: "0.5px solid rgba(255, 255, 255, 0.12)",
                    }}
                  >
                    <Td style={{ paddingLeft: "20px" }}>
                      <Checkbox
                        checked={checkedListStorage.some(
                          (item02) => item02.id === item.id
                        )}
                        onChange={() => {
                          if (
                            checkedListStorage.length > 0 &&
                            checkedListStorage.some(
                              (item02) => item02.id === item.id
                            )
                          ) {
                            let temp = checkedListStorage.filter(
                              (item02) => item02.id !== item.id
                            );
                            setCheckedListStorage(temp);
                          } else {
                            setCheckedListStorage([
                              item,
                              ...checkedListStorage,
                            ]);
                          }
                        }}
                      />
                    </Td>
                    <Td>
                      <TableText>{item.numbering}</TableText>
                    </Td>
                    {/* 라이팅링크로 유입된 계정 */}
                    <Td>
                      <div
                        style={{
                          display: "flex",

                          justifyContent: "center",
                          flexDirection: "column",
                          gap: 2,
                        }}
                      >
                        <PretendardText
                          style={{
                            fontSize: "13px",
                            fontWeight: "500",
                            lineHeight: "18.75px",
                            color: "rgba(181, 181, 181, 0.5)",
                          }}
                        >
                          {item?.recipientName || ""}
                        </PretendardText>
                        <PretendardText
                          style={{
                            fontSize: "13px",
                            fontWeight: "500",
                            lineHeight: "18.75px",
                            color: "rgba(181, 181, 181, 0.5)",
                          }}
                        >
                          {item?.recipientEmail || ""}
                        </PretendardText>
                      </div>
                    </Td>
                    {/* 초대한 계정 */}
                    <Td>
                      <div
                        style={{
                          display: "flex",

                          justifyContent: "center",
                          flexDirection: "column",
                          gap: 2,
                        }}
                      >
                        <PretendardText
                          style={{
                            fontSize: "13px",
                            fontWeight: "500",
                            lineHeight: "18.75px",
                            color: "rgba(181, 181, 181, 0.5)",
                          }}
                        >
                          {item?.senderName || ""}
                        </PretendardText>
                        <PretendardText
                          style={{
                            fontSize: "13px",
                            fontWeight: "500",
                            lineHeight: "18.75px",
                            color: "rgba(181, 181, 181, 0.5)",
                          }}
                        >
                          {item?.senderEmail || ""}
                        </PretendardText>
                      </div>
                    </Td>
                    {/* 지급 형태 */}
                    <Td>
                      <TableText>
                        {item?.cashFlag ? "현금" : "포인트"}
                      </TableText>
                    </Td>
                    {/* 지급 금액 */}
                    <Td>
                      <TableText>{`${formatNumberWithCommas(
                        item?.amount || 0
                      )}${item?.cashFlag ? "원" : "P"}`}</TableText>
                    </Td>
                    {/* 상태 */}
                    <Td>
                      <TableText
                        style={{
                          color: `${
                            item?.distributeStatus ? "#aaa" : "#cf6679"
                          }`,
                        }}
                      >
                        {item?.distributeStatus ? "지급완료" : "미지급"}
                      </TableText>
                    </Td>
                    {/* 보기 */}
                    <Td>
                      <DetailBtn
                        onClick={() => {
                          navigate(`${route.crew_link_detail}/${item.id}`);
                          scrollToTop();
                        }}
                      />
                    </Td>
                  </Tr>
                );
              })}
            </tbody>
          </Table>
          {/* 페이지네이션 영역 */}
          <Pagination
            route={route.crew_link}
            queryString={`&keyword=${keyword}&distribute=${distributeFilter}`}
            currentPage={page}
            totalPages={pagination.totalPages}
            rangeSize={pagination.rangeSize}
            first={pagination.first}
            last={pagination.last}
          />
        </DetailPageLayout>
      </MainLayout>

      {popupOpen && (
        <PopupOverLay
          isOpen={true}
          onClick={() => {
            setPopupOpen({
              ...popupOpen,
              cancelApprove: false,
            });
          }}
        >
          <Popup
            headerTitle="라이팅링크 설정"
            footerBtnText="저장하기"
            onClick={() => {
              setPopupOpen(false);
            }}
            footerBtnHandler={() => {
              updateWritingLinkSettingStatus();
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                padding: "0px 30px",
                gap: 33,
                margin: "32px 0px 100px 0px",
              }}
            >
              <PretendardText
                style={{
                  fontWeight: 500,
                  fontSize: 15,
                  lineHeight: "21.5px",
                  color: "#aaa",
                  height: "fit-content",
                }}
              >
                포인트 자동지급
              </PretendardText>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 24,
                }}
              >
                <Radio
                  id={"payment"}
                  valueText={"지급"}
                  checked={writingLinkSettingStatus}
                  onChange={() => {
                    setWritingLinkSettingStatus(true);
                  }}
                />
                <Radio
                  id={"interruption"}
                  valueText={"중단"}
                  checked={!writingLinkSettingStatus}
                  onChange={() => {
                    setWritingLinkSettingStatus(false);
                  }}
                />
              </div>
            </div>
          </Popup>
        </PopupOverLay>
      )}

      {/* 알림 보내기 */}
      {alarmPopupOpen && (
        <AlarmSendPopup
          setPopupOpen={setAlarmPopupOpen}
          userCheckedIdList={checkedListStorage.map((item) => {
            return {
              id: item.id,
              email: item.senderEmail,
            };
          })}
          getMemberList={getWritingLinkList}
          sessionStorageInit={sessionStorageInit}
          setButtonGroupOpen={setButtonGroupOpen}
        />
      )}

      {/* SMS 보내기 */}
      {smsPopupOpen && (
        <SMSSendPopup
          setPopupOpen={setSMSPopupOpen}
          userCheckedIdList={checkedListStorage.map((item) => {
            return {
              phoneNumber: item.senderPhoneNumber,
            };
          })}
          getMemberList={getWritingLinkList}
          sessionStorageInit={sessionStorageInit}
          setButtonGroupOpen={setButtonGroupOpen}
        />
      )}
    </>
  );
};

export default WritingLink;

const FilterWrapper = styled.div.attrs((props) => {})`
  padding: 10px;
  border-radius: 3px;
  background: #272829;
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 48px;
  z-index: 5;
`;

const FilterTextWrapper = styled.div.attrs((props) => {})`
  display: flex;
  gap: 1px;
`;

const FilterText = styled(PretendardText).attrs((props) => {})`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 10px;
  color: #aaa;
  font-size: 15px;
  font-weight: 500;
  line-height: 22px;
  border-radius: 3px;
  cursor: pointer;

  &:hover {
    background: #313233;
  }
`;

const CheckboxWrapper = styled.div.attrs((props) => {})`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const CheckboxText = styled(PretendardText).attrs((props) => {})`
  font-size: 15px;
  font-weight: 500;
  line-height: 21.5px;
  color: #aaa;
`;
